module.exports = __webpack_public_path__ + "img/mind_skeleton_time_13.6eb34ba5.jpg";